import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { RepayQuery, RepayVo } from './type';

/**
 * 重新支付收银台
  POST /api/order/buyer/repay/cashier
  接口ID：253151202
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-253151202
 */
export const postCashierRepay = (data: RepayQuery): AxiosPromise<RepayVo> => {
  return request({
    url: '/api/order/buyer/repay/cashier',
    method: 'post',
    data
  });
};
